import { render, staticRenderFns } from "./ArtisioTable.vue?vue&type=template&id=1732284c"
import script from "./ArtisioTable.vue?vue&type=script&lang=js"
export * from "./ArtisioTable.vue?vue&type=script&lang=js"
import style0 from "./ArtisioTable.vue?vue&type=style&index=0&id=1732284c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports